import { Content } from 'src/contexts/ContentContext';
import { ContentId } from 'src/utils/constants/contentId';
import { BulkEditStep } from 'src/WebApiController';

import * as styles from './BulkEditProgressDisplay.css';

interface BulkEditStepMessageProps {
  step: BulkEditStep;
}

export const BulkEditStepMessage = ({ step }: BulkEditStepMessageProps) => {
  return (
    <div className={styles.textMain}>
      {step === BulkEditStep.Initializing ? (
        <Content id={ContentId.BulkEditStarting} />
      ) : step === BulkEditStep.InProgress ? (
        <Content id={ContentId.BulkEditInProgress} />
      ) : step === BulkEditStep.Done ? (
        <Content id={ContentId.BulkEditDone} />
      ) : step === BulkEditStep.DoneWithRetryableEntities ? (
        <Content id={ContentId.BulkEditDone} />
      ) : step === BulkEditStep.Cancelled ? (
        <Content id={ContentId.BulkEditCancelled} />
      ) : null}
    </div>
  );
};
